var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.5C14.5547 0.5 17.8359 2.41406 19.6328 5.5C21.4297 8.625 21.4297 12.4141 19.6328 15.5C17.8359 18.625 14.5547 20.5 11 20.5C7.40625 20.5 4.125 18.625 2.32812 15.5C0.53125 12.4141 0.53125 8.625 2.32812 5.5C4.125 2.41406 7.40625 0.5 11 0.5ZM10.0625 5.1875V10.5C10.0625 10.8125 10.2188 11.125 10.4531 11.2812L14.2031 13.7812C14.6328 14.0938 15.2188 13.9766 15.5312 13.5469C15.8047 13.1172 15.6875 12.5312 15.2578 12.2188L11.9375 10.0312V5.1875C11.9375 4.67969 11.5078 4.25 11 4.25C10.4531 4.25 10.0625 4.67969 10.0625 5.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.09a53a9f4351be856386f0a7d4a06c86.svg";
export { ForwardRef as ReactComponent };